
import _ from "lodash";
import { useEffect, useState } from "react";

// This hook is used to watch for a change in a value at a given interval
// and returns the new value
// opts is an object with the following properties:
// - name: the name of the value to watch
// - initialValue: the initial value to set
// cb: the callback function to call to get the new value
// - Return type of cb:
//   { value: any, done: boolean }
//   Once done is true, the interval is stopped
// cb_args: the arguments to pass to the callback function
const useIntervalWatcher = (interval, opts, cb, ...cb_args) => {
    const [newValue, setNewValue] = useState(opts.initialValue);
    const [intervalIdState, setIntervalIdState] = useState(null);

    useEffect(() => {
        const intervalId = setInterval(() => {
            const { value, done } = cb(...cb_args);
            if (done) {
                clearInterval(intervalId);
                setIntervalIdState(null);
            }
            if (newValue !== value) {
                setNewValue(_.cloneDeep(value));
            }
        }, interval);
        setIntervalIdState(intervalId);
        return () => {
            if (intervalIdState) {
                clearInterval(intervalIdState);
                setIntervalIdState(null);
            }
        };
    }, []);

    return newValue;
}

export default useIntervalWatcher;